var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"grey lighten-2"},[_c('router-view',{on:{"page-mounted":_vm.handlePageMounted}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }